/**
 * fireConfetti — the "big moment" celebration burst, shared so every
 * ceremonial screen (network verified, onboarding complete, …) fires
 * the exact same effect instead of each one growing its own bespoke
 * animation. iter753 · extracted out of NetworkVerifiedCelebration.js
 * so AthleteOnboardingFlow.jsx's end-of-onboarding moment could reuse
 * it too — Jay: the onboarding one looked like "random water" (plain
 * black/white dots falling straight down), not real confetti.
 */
import confetti from 'canvas-confetti';

export const CONFETTI_COLORS = ['#3B82F6', '#60A5FA', '#22D3EE', '#FFFFFF', '#FDE047'];

/** Multi-burst confetti — a center burst + two side cannons a beat
 *  later, so the effect feels ceremonial without being obnoxious. */
export const fireConfetti = (colors = CONFETTI_COLORS) => {
  const defaults = { startVelocity: 40, spread: 360, ticks: 80, zIndex: 9999, gravity: 0.9 };
  // Center burst
  confetti({ ...defaults, particleCount: 90, origin: { x: 0.5, y: 0.3 }, colors });
  // Side cannons after a short delay
  setTimeout(() => {
    confetti({ ...defaults, particleCount: 60, angle: 60, spread: 55, origin: { x: 0, y: 0.6 }, colors });
    confetti({ ...defaults, particleCount: 60, angle: 120, spread: 55, origin: { x: 1, y: 0.6 }, colors });
  }, 250);
};
